




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class EventArea extends Vue {}
